import { Text } from '@simplywallst/ui-core';
import { Wrapper, Icon } from './styled';

interface Props {
  disclaimer?: string;
}

const Disclaimer = ({ disclaimer }: Props) => {
  return (
    <Wrapper alignItems="center" templateColumns="24px auto" gap="6px">
      <Icon />
      <Text typography="xSmall" color="white" data-cy-id="disclaimer">
        {disclaimer ||
          'Simply Wall St has no position in any of the companies mentioned.'}
      </Text>
    </Wrapper>
  );
};

export default Disclaimer;
